var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoint3Icon22(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "point3icon2-2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75.924,
    height: 94.149,
    viewBox: "0 0 75.924 94.149",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_136",
    "data-name": "\\u9577\\u65B9\\u5F62 136",
    width: 75.924,
    height: 94.149,
    fill: "#5f7cae"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_102",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 102",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_156",
    "data-name": "\\u30D1\\u30B9 156",
    d: "M5.937,45.472c.3-2.744.3-2.744,4.609-3.057l-.808-2.931c-1.1,0-2.168-.016-3.236,0-1.351.025-1.957-.628-1.947-1.968.02-2.719.028-5.439,0-8.158-.017-1.454.66-2.077,2.083-2.026,1,.036,2.011.007,2.8.007l4.2-10.181c-.388-.285-1.165-.822-1.906-1.4-1.461-1.15-1.257-2.234.036-3.436,1.759-1.635,3.46-3.339,5.1-5.1,1.2-1.292,2.28-1.462,3.456-.039.564.682,1.153,1.343,1.575,1.833l9.994-4.15c0-.689.028-1.745-.007-2.8C31.835.635,32.485-.013,33.928,0,36.584.039,39.241.05,41.9,0c1.538-.028,2.212.64,2.144,2.165-.045,1-.009,2.008-.009,2.7L54.1,9.066c.463-.558,1.127-1.4,1.835-2.2a1.589,1.589,0,0,1,2.612-.109q3.025,3.011,6.041,6.032a1.6,1.6,0,0,1-.046,2.615c-.786.73-1.585,1.446-2.182,1.989l4.142,9.951c.591,0,1.533.052,2.468-.011,1.672-.113,2.458.537,2.4,2.294-.077,2.527-.065,5.06,0,7.588.039,1.6-.572,2.375-2.222,2.282-.941-.054-1.888-.01-2.943-.01l-.838,2.893c4.377.49,4.377.49,4.538,3.076l1.594.11A4.492,4.492,0,0,1,75.9,50.12q.047,19.731,0,39.463c-.008,2.841-2.028,4.555-5.153,4.556q-27.605.009-55.211,0c-3.541,0-7.083.019-10.625-.006C1.9,94.115.019,92.288.014,89.317q-.028-19.447,0-38.894c0-3.213,1.767-4.676,5.923-4.951M36.4,60.74a15.31,15.31,0,0,1-2.577-.035c-.621-.113-1.514-.381-1.722-.837-1.281-2.825-3.448-5.294-3.369-8.7a18.694,18.694,0,0,0-.776-3.88c-.259-1.3-.912-1.8-2.344-1.774-4.927.105-9.858.037-14.787.045-.543,0-1.085.07-1.569.1V84.842c9.115.973,18.278-1.334,27.144,1.908ZM66.723,45.558h-15c-3.516,0-3.519,0-4.226,3.476a7.177,7.177,0,0,0-.3,1.863c.172,2.407-1.114,4.313-1.953,6.405-1.006,2.509-2.428,4.02-5.321,3.49-.088-.016-.2.112-.37.214V86.75c8.9-3.292,18.159-.878,27.176-1.917Zm1.5-8.958V30.376a14.193,14.193,0,0,0-1.95.014c-1.958.287-2.756-.589-3.23-2.472a34.728,34.728,0,0,0-2.534-6.885c-1.827-3.686-1.937-3.63.775-6.719.065-.074.038-.23.1-.667-.57-.5-1.3-1.1-1.993-1.748-.717-.666-1.4-1.371-2.257-2.221-.535.646-.919,1.069-1.259,1.526-1.235,1.658-2.464,1.557-4.189.487a30.859,30.859,0,0,0-6.508-2.958c-3.936-1.308-3.971-1.2-4.233-5.267-.006-.1-.126-.2-.176-.274H34.923a14.08,14.08,0,0,0,.012,1.845c.293,2.04-.615,2.855-2.6,3.33a32.25,32.25,0,0,0-6.87,2.565c-3.624,1.817-3.567,1.927-6.56-.816-.076-.069-.225-.059-.077-.025l-4.388,4.054c.432.454.774.826,1.128,1.184,2.025,2.048,1.911,1.985.568,4.451a39.959,39.959,0,0,0-2.893,6.544c-1.279,3.881-1.173,3.915-5.179,4.1-.108,0-.211.1-.348.176v5.857c.877,0,1.633.056,2.377-.012,1.517-.139,2.209.462,2.619,2,1.319,4.951.063,4.119,5.818,3.968-3.791-10.45-1.939-19.582,7.178-26.265C33.064,10.752,41.33,10.429,49,15.353,59.1,21.843,61.284,31.322,57.4,42.524a26.583,26.583,0,0,1,3.14.024,1.609,1.609,0,0,0,2.035-1.6c.39-3.315,1.6-5.586,5.646-4.345m-30.3,8.923v.037c2.083,0,4.17.063,6.249-.043A2.2,2.2,0,0,0,45.7,44.6c1.01-1.665,1.842-3.436,2.792-5.138a12.2,12.2,0,0,0-2.649-15.293A12.155,12.155,0,0,0,27.485,39.55c1.143,1.991,1.835,4.783,3.554,5.751,1.773,1,4.546.222,6.882.222m12.548-3.094c3.487.224,3.5.23,4.593-2.842a17.151,17.151,0,0,0,.8-9.315c-1.476-7.281-5.717-12.188-12.811-14.291-7.125-2.113-13.46-.284-18.467,5.158S18.5,33.025,21,40c.994,2.773,1.438,2.94,4.417,2.262-4.067-8.68-3.073-15.72,2.9-20.533a15.115,15.115,0,0,1,18.933-.344c6.208,4.7,7.3,11.646,3.226,21.047M6.079,48.675c-2.668-.106-3.034.194-3.035,2.4q-.011,18.765,0,37.531c0,2.179.331,2.5,2.562,2.5q14.974.01,29.949,0c.433,0,.865-.09,1.532-.164a15.636,15.636,0,0,0-9.171-2.863c-6.382-.017-12.763,0-19.145-.008-2.47,0-2.69-.224-2.69-2.727q0-17.249,0-34.5ZM39.166,91.108q15.557,0,31.113,0c2.308,0,2.6-.3,2.6-2.658q.007-18.6,0-37.192c0-2.464-.464-2.845-3.037-2.432v2.037q0,17.077,0,34.156c0,2.979-.076,3.052-3.133,3.053-6.262,0-12.524-.011-18.785.008a13.417,13.417,0,0,0-8.758,3.031M31.978,51.554H43.984l.459-2.876H31.566a5.324,5.324,0,0,0,.006.811c.116.674.262,1.342.406,2.064m1.18,3.184c.782,2.969.782,2.969,3.572,2.969h2.461c2.793,0,2.793,0,3.572-2.969Z",
    transform: "translate(0 0)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_129",
    "data-name": "\\u9577\\u65B9\\u5F62 129",
    width: 18.022,
    height: 2.808,
    transform: "translate(12.267 63.881)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_130",
    "data-name": "\\u9577\\u65B9\\u5F62 130",
    width: 18.048,
    height: 2.791,
    transform: "translate(12.246 69.99)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_131",
    "data-name": "\\u9577\\u65B9\\u5F62 131",
    width: 17.976,
    height: 2.82,
    transform: "translate(12.301 76.048)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_132",
    "data-name": "\\u9577\\u65B9\\u5F62 132",
    width: 11.926,
    height: 2.857,
    transform: "translate(15.315 57.811)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_133",
    "data-name": "\\u9577\\u65B9\\u5F62 133",
    width: 18.041,
    height: 2.769,
    transform: "translate(45.587 63.929)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_134",
    "data-name": "\\u9577\\u65B9\\u5F62 134",
    width: 18.048,
    height: 2.808,
    transform: "translate(45.641 69.954)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_135",
    "data-name": "\\u9577\\u65B9\\u5F62 135",
    width: 17.976,
    height: 2.826,
    transform: "translate(45.699 76.045)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_157",
    "data-name": "\\u30D1\\u30B9 157",
    d: "M140.212,152.376v2.905H128.236v-2.905Z",
    transform: "translate(-79.563 -94.54)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_158",
    "data-name": "\\u30D1\\u30B9 158",
    d: "M100.184,67.223V64.54c3.869-.824,9.139,3.562,8.971,8.718H106.3a6.475,6.475,0,0,0-6.115-6.035",
    transform: "translate(-62.158 -39.981)",
    fill: "#5f7cae"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint3Icon22);
export default __webpack_public_path__ + "static/media/point3icon2-2.428d1f0f294b4a989e814ea4aae5b92c.svg";
export { ForwardRef as ReactComponent };